import {
  CHECK_STOCK_AVAILABILITY_REQUEST,
  CHECK_STOCK_AVAILABILITY_SUCCESS,
  CHECK_STOCK_AVAILABILITY_ERROR,
  GET_SER_DEVICE_LIST_REQUEST,
  GET_SER_DEVICE_LIST_SUCCESS,
  GET_SER_DEVICE_LIST_ERROR
} from './actionTypes';
import { ICheckStockAvailabilityPayload } from './models/types';

export const getDeviceListForSerFlow = {
  request: () => ({ type: GET_SER_DEVICE_LIST_REQUEST }),
  success: (data) => ({ type: GET_SER_DEVICE_LIST_SUCCESS, data }),
  failure: (error) => ({ type: GET_SER_DEVICE_LIST_ERROR, error })
};

export const checkStockAvailability = {
  request: (payload: ICheckStockAvailabilityPayload, callback) => ({
    type: CHECK_STOCK_AVAILABILITY_REQUEST,
    payload,
    callback
  }),
  success: (data) => ({ type: CHECK_STOCK_AVAILABILITY_SUCCESS, data }),
  failure: (error) => ({ type: CHECK_STOCK_AVAILABILITY_ERROR, error })
};
